import * as $ from "jquery";
import * as ko from "knockout";
import Shiftbook from "../shiftbook";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import BaoDialog from "./../../factories/bao-dialog";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import TabPage from "./../../factories/tab-page";
import Bao from "./../../services/bao-service";

/**
 * ViewModel tab containing collections of WorkItemTypes attached to WorkItemCollection/Shiftbook
 */
class ShiftbookWorkItemTypeTab extends GenericListSearchTab {

    //#region Constructors

    /**
     * Constructor
     * @param tabPage
     * @param parent
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
    }

    //#ednregion

    //#region Properties

    /**
     * Is possible save 
     */
    SaveAllowed: KnockoutObservable<boolean>;

    //#endregion
    SearchType() { return "WorkItemType"; }

    //#region Public methods

    /**
     * Custom filters
     * @returns array of filters
     */
    CustomFilter() {
        return null;
    }

    /**
     * Checks if everything is set up correctly
     * @returns
     */
    ItemCompleteCheck(): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }

    /**
     * Returns Id of parent
     * @returns
     */
    GetParentId(): string {
        return ko.unwrap((this.Parent as Shiftbook).WorkItemCollectionId);
    }

    /**
     * Saves a record when selected from a dialog
     * @param searchItem
     * @returns
     */
    protected SaveSelectedItem(searchItem: any): JQueryPromise<any> {
        return Bao.post(this.UrlSaveSearchItem(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId(),
            id: ko.unwrap(searchItem.PrimaryKeyValue)
        }), (serverResult: {
            Message: string;
            Result: boolean;
        }) => {
            if (serverResult.Result) {
                return true;
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, serverResult.Message, "info");
                return false;
            }
        });
    }

    //#endregion
}
export default ShiftbookWorkItemTypeTab;